import { useState, useRef } from "react";
import { Box, SxProps, Typography, Divider, Tooltip } from "@mui/material";
import FullCalendar from '@fullcalendar/react'
import interactionPlugin from "@fullcalendar/interaction"
import enLocale from '@fullcalendar/core/locales/en-au';
import thLocale from '@fullcalendar/core/locales/th';
import timeGridPlugin from '@fullcalendar/timegrid';
// import listPlugin from '@fullcalendar/list';
import dayGridPlugin from '@fullcalendar/daygrid'
//CSS
import StyleCalendar from "./Style";
import { Add, Sell, PlayArrow, Place, Circle } from "@mui/icons-material";
import PropTypes from "prop-types";
import { Stack } from "@mui/system";

export const TemplateColor = {
    ColorPrimary: "#0070ff",
    ColorPrimaryHover: "#005cff",
    ColorSecond: "#314099",
    ColorDanger: "#ed3847",
    ColorDangerHover: "#dd1212",
    BoxShadowDown: "0 4px 8px 0 #cbcbcb",

    MeetingColor: "#FEBE8C",
    MeetingDarkColor: "#FF8E36",
    MeetingHover: "#F7B37C",
    EventColor: "#B6E2A1",
    EventDarkColor: "#73CC47",
    EventHover: "#A1DE85",
};

export default function CalendarGlobal(props) {
    const { Event, OnDateClick, initialView, onCalenderChange, maxWidth, height, small } = props;
    const [isOpen, setisOpen] = useState(false);
    const [lstME_Show, setlstME_Show] = useState([]);

    const refCalendar = useRef(null);
    const renderEventContent = (eventInfo) => {
        // let sClassname = "";
        // let sTooltip = eventInfo.event.extendedProps.isEvent ? "Event" : "Meeting";
        // if (eventInfo.view.type === "dayGridMonth" && small) {

        //     if (eventInfo.event.extendedProps.isEvent) {
        //         sClassname = "type-event";
        //     } else {
        //         sClassname = "type-meeting";
        //     }
        // } else if (eventInfo.event.extendedProps.isEvent) {
        //     sClassname = "bg-type-event";
        // } else {
        //     sClassname = "bg-type-meeting";
        // }

        // let data = eventInfo.event;
        // if (small && !data.extendedProps.isShow && eventInfo.view.type === "dayGridMonth") return null;

        // return <>
        //     {(small && eventInfo.view.type === "dayGridMonth")
        //         ? <Tooltip title={sTooltip} disableInteractive >
        //             <Sell className={`small ${sClassname}`} />
        //         </Tooltip>
        //         :
        //         <>
        //             {eventInfo.view.type === "dayGridMonth" ?
        //                 <Stack spacing={2}>
        //                     <div>
        //                         <label className="label-event">{data.title}</label>
        //                     </div>
        //                 </Stack>
        //                 : <Stack spacing={2}>
        //                     <div>
        //                         <label className="label-event"><PlayArrow className="arrow-label" />{data.title}</label>
        //                     </div>
        //                 </Stack>
        //             }
        //         </>}
        // </>

        return (
            <>
                <Tooltip title={eventInfo.event.title}>
                    <i style={{
                        padding: "0 8px", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer"
                    }}>{eventInfo.event.title}</i>
                </Tooltip>
            </>
        )
    }

    const handleClose = () => {
        setisOpen(false);
        setlstME_Show([]);
    }

    const handleClickEvent = (e) => {
        let ev = e.event.extendedProps;

        if (ev.lstME && ev.lstME.length > 0) {
            setlstME_Show([...ev.lstME]);
        } else {
            let objData = JSON.parse(JSON.stringify(ev)) as any;
            objData.title = e.event.title;
            // setlstME_Show([ev]);
            // objData.title = e.event._def.title;
            // objData.sLocation = e.event.extendedProps.sLocation;
            setlstME_Show([objData]);
        }
        setisOpen(true);
        if (OnDateClick) OnDateClick(e)
    }


    return (
        <Box sx={StyleCalendar(props)} className={small ? "small-calendar" : ""} maxWidth={maxWidth} id="box-carlendar">
            {/* <FullCalendar
                ref={refCalendar}
                locale={enLocale}
                plugins={[dayGridPlugin,
                    interactionPlugin,
                    timeGridPlugin
                    // listPlugin
                ]}
                firstDay={0}
                allDaySlot={false}
                dayMaxEvents={small ? false : true}
                dayMaxEventRows={small ? 3 : false}
                eventContent={renderEventContent}
                initialView={initialView ? "dayGridMonth" : "timeGridWeek"}
                headerToolbar={{
                    // left: small ? '' : 'customBtnAdd',
                    left: '',
                    center: 'prev,title,next',
                    right: "timeGridDay,timeGridWeek,dayGridMonth",
                }}
                eventTimeFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: true
                }}
                // dayMaxEvents={1}
                eventClick={handleClickEvent}
                // dateClick={(e) => { OnDateClick(e); }}
                events={Event}
                eventDisplay={"block"}
                datesSet={(e) => {
                    if (onCalenderChange) onCalenderChange(e);
                }}
                dayHeaderClassNames={"day-header"}
                eventClassNames={"event-item"}
                viewClassNames={'calendar-view'}
                // customButtons={{ ...CustomeProps } as any}
                height={height}
            /> */}

            <FullCalendar
                ref={refCalendar}
                locale={thLocale}
                plugins={[dayGridPlugin,
                    interactionPlugin,
                    timeGridPlugin
                ]}
                firstDay={0}
                allDaySlot={false}
                initialView='dayGridMonth'
                events={Event}
                eventContent={renderEventContent}
                dayMaxEvents={!small}
                dayMaxEventRows={small ? 3 : false}
                headerToolbar={{
                    left: '',
                    center: 'prev,title,next',
                    // right: "timeGridDay,timeGridWeek,dayGridMonth",
                    right: 'today'
                }}
                eventTimeFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: true
                }}
                eventDisplay={"block"}
                datesSet={(e) => {
                    if (onCalenderChange) onCalenderChange(e);
                }}
                dayHeaderClassNames={"day-header"}
                // eventClassNames={"event-item"}
                // viewClassNames={'calendar-view'}
                height={height}
            />
            {/* {small ?
                <Stack justifyContent={'center'} alignItems={'center'} direction={'row'} spacing={2} mt={1} sx={{ fontSize: '12px', '.icon': { fontSize: '12px', marginRight: '4px' } }}>
                    <Circle className="icon" sx={{ color: TemplateColor.MeetingColor }} /> Meeting
                    <Circle className="icon" sx={{ color: TemplateColor.EventColor }} /> Event
                </Stack>
                : null} */}
        </Box>
    );
}

export const RenderCalenderDetail = ({ data }) => (
    <Box sx={dialogContentStyle}>
        <Typography variant="body1" className="head"><Sell className="icon" sx={{ color: data.isEvent ? TemplateColor.EventColor : TemplateColor.MeetingColor }} />{data.sDay} {data.sMonthYear} {data.sTime}</Typography>
        <Divider />
        <Typography variant="subtitle1"><b>Topic : </b></Typography>
        <Typography variant="subtitle1">{data.title}</Typography>
        <Typography variant="subtitle1" mt={1} ><b>Location : </b></Typography>
        <Typography variant="subtitle1">{data.sLocation}</Typography>
    </Box>
)

export const dialogContentStyle: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    padding: "0.5em",
    borderRadius: '1em',
    wordBreak: 'break-all',
    marginTop: '0.5em',
    marginBottom: '0.5em',
    boxShadow: TemplateColor.BoxShadowDown,
    color: '#525252',
    '.head': {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        color: '#407cff',

        '.icon': {
            marginRight: '4px',
            fontSize: '20px',
        }
    },
    '.MuiDivider-root': {
        margin: '4px 0',
    },
};

CalendarGlobal.prototype = {
    Event: PropTypes.array,
    OnDateClick: PropTypes.func,
    initialView: PropTypes.func,
    onCalenderChange: PropTypes.func,
    maxWidth: PropTypes.number,
    height: PropTypes.number,
    small: PropTypes.bool,
    isGroup: PropTypes.bool,
}

// AutoCompleteSelect.defaultProps = {
//     isOptionTwoLanguage: false
// };


